import { c as _c } from "react/compiler-runtime";
import { SphereLabel } from "@components/common/sphere-label";
import { SphereTooltipIcon } from "@components/common/sphere-tooltip-icon";
/**
 * Renders a label that can be used inside dialogs.
 * The component take the full width of the parent and on the left side
 * places a label. If provided, places on the right side a help icon
 * with a tooltip showing some help text.
 */
export function LabelWithHelp(t0) {
  const $ = _c(8);
  const {
    title,
    help,
    isRequired: t1,
    isDisabled: t2,
    sx
  } = t0;
  const isRequired = t1 === undefined ? false : t1;
  const isDisabled = t2 === undefined ? false : t2;
  let t3;
  if ($[0] !== help) {
    t3 = help ? <SphereTooltipIcon text={help} /> : undefined;
    $[0] = help;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== isDisabled || $[3] !== isRequired || $[4] !== sx || $[5] !== t3 || $[6] !== title) {
    t4 = <SphereLabel title={title} isRequired={isRequired} isDisabled={isDisabled} rightSideComponent={t3} sx={sx} />;
    $[2] = isDisabled;
    $[3] = isRequired;
    $[4] = sx;
    $[5] = t3;
    $[6] = title;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
}